import { render, staticRenderFns } from "./load-content.vue?vue&type=template&id=161ad35e&scoped=true"
import script from "./load-content.vue?vue&type=script&lang=js"
export * from "./load-content.vue?vue&type=script&lang=js"
import style0 from "./load-content.vue?vue&type=style&index=0&id=161ad35e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161ad35e",
  null
  
)

export default component.exports